module.exports = __webpack_public_path__ + "static/media/eames-lounge-chair-charles-and-ray-eames.7f9de683.jpg";